import landing from './landing'

export default {
  ...landing
}
